<template>
  <div>
    <div class="form-wrapper eDetails" style="border-top: none; width: 100%">
          <router-view
                       class="h-100 d-flex align-content-between flex-wrap">
          </router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountStatements',
  data() {
    return {

    };
  },
  mounted() {
  },
};
</script>
